// extracted by mini-css-extract-plugin
export default {"root_scroller":"O0","flex_container":"P0","container":"Q0","scroller":"R0","indicator":"S0","scrollButtons":"T0","selected":"U0","root_tab":"V0","root_tab_scrollable":"W0","root_scroller_mob":"X0","scroller_mob":"Y0","indicator_mob":"Z0","selected_mob":"a1","root_tab_mob":"b1","root_tab_mob_scrollable":"c1"};
    if(module.hot) {
      // 1726593107847
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  